<template>
  <div>
    <router-view></router-view>
    <appAlert />
  </div>
</template>

<script>
import appAlert from "@/packages/dashboard/plugins/appAlert/appAlert";
export default {
  name: "ReinstatementComponent",
  components: { appAlert },
};
</script>
